var ImageCrop;!function(a){a.Fit="fit",a.Fill="fill"}(ImageCrop=ImageCrop||{});var ImageCrop$1=ImageCrop;export{ImageCrop$1 as default};
